import styled from "styled-components";

import { colors } from "shared/ui/tokens";

export const Sheet = styled.div`
    background: ${colors.surface};
    border-radius: 16px 16px 0 0;
    padding: 8px 0 max(12px, env(safe-area-inset-bottom));
    /* Лист не выше экрана: список категорий длинный, прокручиваться должен он, а не страница. */
    max-height: 85vh;
    display: flex;
    flex-direction: column;
`;

export const Grabber = styled.div`
    width: 36px;
    height: 4px;
    margin: 0 auto 8px;
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.18);
`;

export const Head = styled.header`
    padding: 4px 16px 8px;
`;

export const Title = styled.h2`
    margin: 0;
    font-size: 1.0625rem;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const Body = styled.div`
    padding: 0 16px;
    overflow-y: auto;
`;
